import { render, staticRenderFns } from "./ChatSelectedMsg.vue?vue&type=template&id=5db837da&scoped=true&lang=pug"
import script from "./ChatSelectedMsg.vue?vue&type=script&lang=js"
export * from "./ChatSelectedMsg.vue?vue&type=script&lang=js"
import style0 from "./ChatSelectedMsg.vue?vue&type=style&index=0&id=5db837da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db837da",
  null
  
)

export default component.exports